module.exports = __webpack_public_path__ + "static/media/decentro.149f16eb.svg";